export default __webpack_public_path__ + "static/media/Sermons_Home page thumnail.27dac288.jpg";